import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import InventoryIcon from '@mui/icons-material/Inventory';
import { Button, Switch, Tooltip } from '@mui/material';
import { Stack } from '@mui/system';

import PageTitle from '@/shared/components/layouts/PageTitle';
import { AppPath } from '@/shared/constants/path';

type TitleProps = {
  shouldPersistForm: boolean;
  setShouldPersistForm: (value: boolean) => void;
  handleMetadataCreate: () => void;
  handleSaveChanges: () => void;
};

const Title: FC<TitleProps> = ({
  shouldPersistForm,
  setShouldPersistForm,
  handleMetadataCreate,
  handleSaveChanges,
}) => {
  const { t } = useTranslation(['inventory', 'common']);

  return (
    <PageTitle
      title={t('common:inventory')}
      breadcrumbs={[
        {
          label: t('common:inventory'),
          to: AppPath.Inventory,
          icon: (
            <InventoryIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
        },
        {
          label: t('inventory:breadcrumb.inventoryAdd'),
          icon: (
            <InventoryIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
        },
      ]}
      actions={
        <Stack direction='row' spacing={1}>
          <Tooltip title='Persist Inventory Form' placement='left' arrow>
            <Switch
              checked={shouldPersistForm}
              onChange={(_, checked) => setShouldPersistForm(checked)}
              inputProps={{ 'aria-label': 'persist-inventory-form' }}
            />
          </Tooltip>
          <Button
            onClick={handleMetadataCreate}
            color='primary'
            variant='outlined'
          >
            {t('common:createMetadata')}
          </Button>
          <Button
            onClick={handleSaveChanges}
            color='primary'
            variant='contained'
          >
            {t('common:saveChanges')}
          </Button>
        </Stack>
      }
    />
  );
};

export default Title;
